import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ClarityOpsPanelComponent } from './lib/clarity-ops-panel.component'
import { ClarityOpsKey } from './panel-key'

export * from './lib/clarity-ops.module'
export * from './panel-key'

export const ClarityOpsPanelConfig: PanelConfig = {
  key: ClarityOpsKey,
  title: 'ClarityOps',
  description:
    'GenAI-powered interactive dashboards for reconciliation operations — Yellow Errors, OPR Reports, Cash Plug, and Exception Metrics.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: ClarityOpsPanelComponent,
  accessPermission: 'accessClarityOpsPanel',
}
